import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Upload, Button} from 'antd'
import {UploadOutlined} from '@ant-design/icons'
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
const storage = window.localStorage

@inject('marketingSmsManagementStore', 'accountStore')
@observer
class FormImport extends Component {
  formRef = React.createRef()
  beforeUpload = (file, FileList) => {
    return true
  }

  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)

    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`
    }
  }

  onChange = (info) => {
    const {marketingSmsManagementStore, accountStore, handleCancel, type, smsType, sourceType, isTable} = this.props
    const { generateID } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn)
      } else {
        const value = info.file.response.data
        if(isTable) {
          marketingSmsManagementStore.onExcelViewAction({
            "configName": "",
            "marketGroupId": "",
            "sourceType": sourceType,
            "taskGroupId": generateID,
            'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT
          }).then(res=>{
            if(res?.data?.code ===0) {
              handleCancel()
            }
          })
        } else {
          marketingSmsManagementStore.onPhoneAction({
            'sourceType': sourceType,
            'phone': '',
            'taskGroupId': generateID,
            'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT
          }).then(res=>{
            if(res?.data?.code ===0) {
              handleCancel()
            }
          })
        }
        marketingSmsManagementStore.onStatisticsAction({
          "smsType": smsType,
          "taskGroupId": generateID,
          "taskType": type,
        })
        alertMessage.success('导入成功!')
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('导入失败!')
    }
  }

  handleExport = () => {
    const {isTable} = this.props
    // 创建隐藏的链接元素
    const link = document.createElement('a');
    link.href = isTable ? '个性短信导入模板.xlsx' : '/普通短信导入模板.xlsx'; // 文件需要放在 public 目录下
    link.download = isTable ? '个性短信导入模板.xlsx' : '普通短信导入模板.xlsx'; // 设置下载文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const {marketingSmsManagementStore, importModalVisible, handleCancel, sourceType, smsType, type, t, marketGroupId} = this.props
    const { generateID } = marketingSmsManagementStore
    const {Dragger} = Upload
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/market/management/member/import`

    return (
      <>
        <Modal
          title={t(`marketingManagement.importPhoneFile`)}
          // closable={false}
          visible={importModalVisible}
          onCancel={() => { handleCancel('importModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
          width={600}
        >
          <Dragger
            accept=".xlsx"
            action={UPLOAD_TEMPLATE_URL}
            headers={this.getHeader()}
            style={{width: '100%', margin: '0 auto'}}
            onChange={this.onChange}
            data={{
              "smsType": smsType,
              "sourceType": sourceType,
              "taskGroupId": generateID,
              "taskType": type,
              marketGroupId
            }}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{color: '#031a34'}}/>
            </p>
            <p className="ant-upload-text">{t(`dataTarget.dragFile`)}</p>
            <p className="ant-upload-hint" style={{ marginBottom: '10px' }}>
             Download template to fill in and upload
            </p>
          </Dragger>
          <div style={{marginTop: 20, position: 'relative'}}>
            请先下载模板按说明填写信息后上传
            <Button type="primary" onClick={this.handleExport} style={{ position: 'absolute', right: 0,}}>下载模板</Button>
          </div>

        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormImport)
